<template>
  <v-container class="no-margins">
    <h1 class="mb-12">{{ $t("welcome.logged-out.title") }}</h1>

    <div class="pt-5">
      <BankIdLoginButton :buttonText="$t('labels.loginBankID')" />
      <MessageBox class="mt-1" type="info">
        <h6 class="">{{ $t('labels.login') }}</h6>
        <p>{{ $t('welcome.info-login-bankid')}}</p>
      </MessageBox>
    </div>

    <div class="mt-12">
      <PasswordLoginButton :buttonText="$t('labels.login-password')" />
      <MessageBox class="mt-1" type="info">
        <h6 class="">{{ $t('labels.login-password') }}</h6>
        <p v-html="$t('welcome.info-password-login')"></p>
      </MessageBox>
    </div>

    <div class="mt-12">
      <Byn2LoginButton />
      <MessageBox class="mt-1" type="info">
        <h6 class="">{{ $t('labels.login-byn2') }}</h6>
        <p>{{ $t('welcome.info-byn2-login')}}</p>
      </MessageBox>
    </div>

    <MessageBox class="mt-12" type="info">
      <h6 class="">{{ $t('welcome.company-title') }}</h6>
      <p>{{ $t('welcome.company') }}</p>
      <p>
        <a :href="links.main.byn" target="_blank">{{ $t('welcome.company-link') }}</a>
      </p>
    </MessageBox>

    <MessageBox class="mt-1" type="info">
      <h6 class="">{{ $t('welcome.underage-title') }}</h6>
      <p>{{ $t('welcome.underage') }}</p>
      <p>
        <a :href="links.login.minor" target="_blank">{{ $t('welcome.underage-link') }}</a>
      </p>
    </MessageBox>

    <DevLogins v-if="showDevLogin" />
  </v-container>
</template>

<script>
import BankIdLoginButton from '@/components/Common/Login/BankIdLoginButton'
import PasswordLoginButton from '@/components/Common/Login/PasswordLoginButton'
import DevLogins from '@/components/Common/Login/DevLogins'
import MessageBox from '@/components/Common/MessageBox'
import Byn2LoginButton from '@/components/Common/Login/Byn2LoginButton'

export default {
  data: () => ({
    links: require('../../lib/external-links.json'),
    showLogin: false,
    showDevLogin: false
  }),

  components: {
    BankIdLoginButton,
    PasswordLoginButton,
    MessageBox,
    DevLogins,
    Byn2LoginButton
  },

  created() {
    this.showDevLogin = Boolean(process.env.VUE_APP_USE_FAKE_LOGINS === 'true')
    this.$router.replace({ name: 'LoginPage' })
  }
}
</script>

<style></style>
